module.exports = __webpack_public_path__ + "static/media/glass5.ca220c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/glass5.png
// module id = 730
// module chunks = 0